import { render, staticRenderFns } from "./EmployeeDetailDashboardView.vue?vue&type=template&id=34e4addd&scoped=true"
import script from "./EmployeeDetailDashboardView.vue?vue&type=script&lang=js"
export * from "./EmployeeDetailDashboardView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e4addd",
  null
  
)

export default component.exports